import { WeighingTypeEnum } from "../../domain/model/model-enums";
import { Uuid } from "../../domain/model/uuid/uuid.type";
import { SectionViewModel } from "../shared/section.viewmodel";
import { SectionOverviewBatchRowViewModel } from "./section-overview-batch-row.viewmodel";
import { SectionOverviewTrialPhasesViewModel } from "./section-overview-trial-phases.viewmodel";

export class SectionOverviewViewModel {
  constructor(
    readonly trialId: Uuid,
    readonly trialPhases: SectionOverviewTrialPhasesViewModel[],
    readonly section: SectionViewModel,
    readonly batchOverviews: SectionOverviewBatchRowViewModel[]) {
  }

  // never used? 28.08.26
  getInitial(): SectionOverviewBatchRowViewModel | null {
    return this.batchOverviews.find(batch => batch.isInitial()) || null;
  }

  // never used? 28.08.26
  getFinal(): SectionOverviewBatchRowViewModel | null {
    return this.batchOverviews.find(batch => batch.isFinal()) || null;
  }

  // never used? outcommented 28.08.26
  // getInterimOrdered(): SectionOverviewBatchRowViewModel[] {
  //   return this.batchOverviews
  //   .filter(batch => !batch.isInitial() && !batch.isFinal())
  //   .sort((a, b) => a.interimSequenceNumber - b.interimSequenceNumber);
  // }

  maxInterimNumber(): number {
    return Math.max(...this.batchOverviews.map(batch => batch.getMaxInterimNumber()));
  }

  getInterimTrialPhaseByNumber(interimNumber: number): SectionOverviewTrialPhasesViewModel | null {
    const trialPhase = this.trialPhases
      .filter((phase) => phase.type === WeighingTypeEnum.Interim)
      .find(phase => phase.number === interimNumber);
    return trialPhase ?? null;
  }

  firstInsertionDate(): Date | null {
      return this.trialPhases.find(phase => phase.type === WeighingTypeEnum.Initial)?.expectedStartDate ?? null;
  }

  getInterimDate(interimSequenceNumber: number): Date | null {
    const interimPhase = this.trialPhases
      .find(phase => phase.type === WeighingTypeEnum.Interim &&
        phase.number === interimSequenceNumber);
    return interimPhase ? interimPhase.expectedStartDate : null;
  }

  toString(): string {
    return `SectionOverviewViewModel: SectionId: ${this.section.id},
     TrialId: ${this.trialId},
      batchOverviews: ${this.batchOverviews.join(', ')}`;
  }
}
